/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Acknowledge/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Acknowledge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Widget/Check/Acknowledge"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let payersActiveTabValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'activeTab',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<div
  data-testid="Acknowledge.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1PRa2n': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payers.activeTab"
 format="helpers.js getText"
 text={payersActiveTabValueData}
/>
</div>
{children}
</React.Fragment>)
}